import React from 'react';
import {
  Box, Container, Typography, Grid, Stack, Card, CardContent, Rating, Avatar,
} from '@mui/material';
import { Star } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const reviews = [
  {
    name: 'TME', title: 'Problem quickly solved, nerves calmed',
    body: 'Spoke to a real person who smoothly guided me through a problem I was in a panic over. I couldn\'t understand why my website was out of space but she quickly resolved it by pointing out duplicate backups.',
    date: 'Today',
  },
  {
    name: 'Sangla Hill', title: 'Exceptional support from Mr. Jeff',
    body: 'Exceptional support from Mr. Jeff on our domain migration. He turned a potentially messy process into a smooth operation with his sharp problem-solving and outstanding communication. A true pro.',
    date: 'Today',
  },
  {
    name: 'Wollner Martha', title: 'The customer support representative',
    body: 'The customer support representative - Muhammed was the clearest, most expedient and courteous I have had at Hosting Services.',
    date: 'Today',
  },
  {
    name: 'RomanceJourneys', title: 'Gordan is such an asset',
    body: 'Gordan is such an asset to Hosting Services. So patient and knowledgeable. 5*\'s all the way.',
    date: 'Today',
  },
  {
    name: 'Vi', title: 'After a year of using them I am happy',
    body: 'After a year of using them I am rather happy with the service. They have been prompt to answer any issues I have had. The site is easy to use.',
    date: 'Today',
  },
  {
    name: 'Ed Dellis', title: 'Quick Screenshot Exchanges',
    body: 'My tech support chat rep was very patient and responded quickly. The exchange of screenshots was very helpful and allowed me to zero-in on where to click efficiently.',
    date: 'Today',
  },
];

const VpsReviews = () => (
  <Section id="reviews" sx={{ background: C.bgSection, borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <SectionLabel>PROVEN TRUST</SectionLabel>
        <Typography variant="h2" sx={{
          fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.5rem' },
          color: C.textPrimary, letterSpacing: '-0.03em', mb: 1.5,
        }}>
          See why we’re trusted by over 5 million WordPress users
        </Typography>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
          <Rating value={4.5} precision={0.5} readOnly sx={{ color: '#F59E0B' }} />
          <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.95rem' }}>
            Excellent 4.5
          </Typography>
          <Typography sx={{ color: C.textMuted, fontSize: '0.95rem' }}>
            Based on 31,046 reviews
          </Typography>
        </Stack>
      </Box>

      {/* Reviews Grid (MUI v6 Grid size) */}
      <Grid container spacing={3}>
        {reviews.map((r) => (
          <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={r.name}>
            <Card elevation={0} sx={{
              border: `1px solid ${C.border}`,
              borderRadius: '14px',
              p: 3,
              height: '100%',
              background: '#FFFFFF',
              display: 'flex', flexDirection: 'column',
              boxShadow: '0 2px 10px rgba(0,0,0,0.03)',
            }}>
              <Rating value={5} readOnly size="small" sx={{ color: '#F59E0B', mb: 1.5 }} />
              <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.95rem', mb: 1 }}>
                {r.title}
              </Typography>
              <Typography sx={{ color: C.textSecondary, fontSize: '0.84rem', lineHeight: 1.6, flex: 1, mb: 2.5 }}>
                {r.body}
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar sx={{ width: 32, height: 32, background: C.primary, fontSize: '0.8rem', fontWeight: 700 }}>
                  {r.name[0]}
                </Avatar>
                <Box>
                  <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.82rem' }}>
                    {r.name}
                  </Typography>
                  <Typography sx={{ color: C.textMuted, fontSize: '0.74rem' }}>
                    {r.date}
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>

    </Container>
  </Section>
);

export default VpsReviews;
